/* 🤖 this file was generated by svg-to-ts */
export const matIconInsertComment: {
  name: 'insert-comment';
  data: string;
} = {
  name: 'insert-comment',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 4v13.17L18.83 16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 10H6v2h12v-2zm0-3H6v2h12V9zm0-3H6v2h12V6z"/></svg>`
};
